export default __webpack_public_path__ + "static/media/avatar-4.e67b8e11.png";